import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '@/pages/index';
import Assistant from '@/pages/assistant';
import Classroom from '@/pages/classroom';
import Propaganda from '@/pages/propaganda';
import Security from '@/pages/security';
import Culture from '@/pages/culture';
import Contact from '@/pages/contact';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/index',
      name: 'helloWorld',
      component: HelloWorld,
      children:[
        {
          path: '/index',
          name: 'index',
          component: Index
        },
        {
          path: '/assistant',
          name: 'assistant',
          component: Assistant
        },
        {
          path: '/classroom',
          name: 'classroom',
          component: Classroom
        },
        {
          path: '/propaganda',
          name: 'propaganda',
          component: Propaganda
        },
        {
          path: '/security',
          name: 'security',
          component: Security
        },
        {
          path: '/culture',
          name: 'culture',
          component: Culture
        },
        {
          path: '/contact',
          name: 'contact',
          component: Contact
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js